// src/store.js
import { configureStore } from "@reduxjs/toolkit";
import usersSlicer from "./Redux/usersSlice";
import settingsSlicer from "./Redux/settingsReduce";

export default configureStore({
  reducer: {
    // Existing  reducers
    users: usersSlicer,
    settings: settingsSlicer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
